import { Routes, Route } from 'react-router-dom';

import alf_logo from './img/cantoesluz-square.jpg';
import react_logo from './img/react.png';
import frameworkless_logo from './img/logo_frameworkless_movement.png';
import flaticon_logo from './img/flaticon.png';

import './css/App.css';
import { getBajada } from './components/editorial/bajada-text.js';

import { Me } from './components/pages/me.js';
import { Menu } from './components/menu.js';
import { useState } from 'react';
import { Hobbies } from './components/pages/hobbies.js';
import { Projects } from './components/pages/projects.js';
import {Work} from './components/pages/work.js';
import ContactForm from './components/ContactForm.js';

function App() {

  const [getLang,setLang] = useState("es");

  return (
    <div className="App">

      <div className="wrapper">
        <header className="App-header">
          Alfredo Cofré
        </header>{/* header */}
        <div className='div-logo'>
          <img className="img-logo" src={alf_logo} alt="logo" width="120px;" />
        </div>{/* div-logo */}
        <div className="bajada">{getBajada(getLang)}</div>{/* app-bajada */}
          <Menu lang={getLang} langsetter={setLang}/>
        <div className='App-body' id="main-body">
          <Routes>
            <Route path="/" element={<Me lang={getLang}/>} />
            <Route path="/work" element={<Work lang={getLang}/>} />
            <Route path="/hobbies" element={<Hobbies lang={getLang}/>} />
            <Route path="/projects" element={<Projects lang={getLang}/>} />
            <Route path="/contact" element={<ContactForm lang={getLang}/>} />
            <Route path="*" element={<Me lang={getLang}/>} />
          </Routes>
        </div>{/* app-body */}
      </div>{/* wrapper */}
      <div className='footer'><a href="https://www.flaticon.com" target="_blank" rel="noreferrer">{<img className="img-footer" src={flaticon_logo} alt="Íconos por Flaticon. No puedo hacer todo." />}</a> <a href="https://react.dev/" target="_blank" rel="noreferrer">{<img className="img-footer" src={react_logo} alt="Hecho con React. Porque sí." />}</a>  
        <a href="https://www.frameworklessmovement.org/" target="_blank" rel="noreferrer">{<img className="img-footer" src={frameworkless_logo} alt="Hecho sin frameworks. Porque no." />}</a></div>
    </div>/* App */
  );
}


export default App;
